module.exports = __webpack_public_path__ + "img/affcontrol-logo-panel.3b3fa254.svg";